import { Box, CircularProgress, Fade, Stack, Typography } from '@mui/material';
import useLayoutContext from '../../hooks/useLayoutContext';

const PageLoad = () => {
  const { isOpenPageLoad } = useLayoutContext();
  return (
    <Box
      sx={{
        position: 'fixed',
        height: '100dvh',
        width: '100vw',
        zIndex: 10000000,
        pointerEvents: isOpenPageLoad ? undefined : 'none',
      }}
    >
      <Fade in={isOpenPageLoad}>
        <Stack
          sx={{
            height: '100dvh',
            width: '100%',
            background: 'rgba(255,255,255,.5)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
          // onClick={closePageLoad}
        >
          <CircularProgress />
          <Typography>Syncing data</Typography>
        </Stack>
      </Fade>
    </Box>
  );
};

export default PageLoad;
